import React from "react";

type CircularProgressProps = {
  percentage: number;
  icon: string;
};

const CircularProgress = ({ percentage, icon }: CircularProgressProps) => {
  const clampedPercentage = Math.min(Math.max(percentage, 0), 100);
  const radius = 32;
  const strokeWidth = 6;
  const normalizedRadius = radius - strokeWidth / 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset =
    circumference - (clampedPercentage / 100) * circumference;
  const progressColor = clampedPercentage === 100 ? "#22c55e" : "#00A3E0";

  return (
    <div className="relative w-16 h-16 flex items-center justify-center">
      <svg
        height={radius * 2}
        width={radius * 2}
        className="absolute"
        style={{ transform: "rotate(-90deg)" }}
      >
        <circle
          stroke="white"
          fill="transparent"
          strokeWidth={strokeWidth}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />
        <circle
          stroke={progressColor}
          fill="transparent"
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          r={normalizedRadius}
          cx={radius}
          cy={radius}
          style={{
            transition: "stroke-dashoffset 0.5s ease, stroke 0.5s ease",
          }}
        />
      </svg>
      <div className="absolute flex items-center justify-center">
        <img src={icon} className="w-12 h-12 rounded-full" />
      </div>
    </div>
  );
};

export default CircularProgress;
